import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.125 17.7084H6.875C6.1849 17.7084 5.625 17.1485 5.625 16.4584V3.54175C5.625 2.85164 6.1849 2.29175 6.875 2.29175H13.125C13.8151 2.29175 14.375 2.85164 14.375 3.54175V16.4584C14.375 17.1485 13.8151 17.7084 13.125 17.7084Z"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.0418 15.2085H8.9585"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.625 4.79175C10.625 5.1368 10.3451 5.41675 10 5.41675C9.65495 5.41675 9.375 5.1368 9.375 4.79175C9.375 4.4467 9.65495 4.16675 10 4.16675C10.3451 4.16675 10.625 4.4467 10.625 4.79175Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
};
